import { useAction } from 'next-safe-action/hooks'

import { addToFavoriteList, type TFavoriteRoomEvent } from '@/entities/room'
import { useAirbridgeContext, useServerErrorHandler } from '@/shared/config'

type AddToFavoriteListActionProps = {
  onSuccess: () => void
}

export const useAddToFavoriteList = ({
  onSuccess,
}: AddToFavoriteListActionProps) => {
  const { handleServerError } = useServerErrorHandler()
  const { sendEvent } = useAirbridgeContext()

  const sendAirbridgeEvent = (airbridgeEvent: TFavoriteRoomEvent) => {
    const params = {
      action: airbridgeEvent.action,
      label: airbridgeEvent.label,
      value: airbridgeEvent.value,
      semanticAttributes: {
        products: [
          {
            productID: airbridgeEvent.productId,
            name: airbridgeEvent.productName,
            categoryName: airbridgeEvent.categoryName,
            price: airbridgeEvent.price,
            position: 1,
            currency: 'KRW',
          },
        ],
        currency: 'KRW',
      },
    }

    sendEvent({
      event: airbridgeEvent.eventName,
      params,
      onSuccess,
    })
  }

  const action = useAction(addToFavoriteList, {
    onSuccess: ({ data }) => {
      if (data?.airbridgeEvent) {
        sendAirbridgeEvent(data.airbridgeEvent)
      }
    },
    onError: ({ error }) => {
      if (error.serverError) {
        handleServerError(error.serverError)
      }
    },
  })

  return action
}
